import { Introduction } from "@/components/molecules/terms/service/Introduction";
import { AritcleDesignatedService } from "@/components/molecules/terms/service/AritcleDesignatedService";
import { AritcleGoverningLawandJurisdiction } from "@/components/molecules/terms/service/AritcleGoverningLawandJurisdiction";
import { AritcleNegotiatedSettlement } from "@/components/molecules/terms/service/AritcleNegotiatedSettlement";
import { TermsLayout } from "@/components/organisms/TermsLayout";
import { ArticleProviderOfSpecifiedService } from "../molecules/terms/service/ArticleProviderOfSpecifiedService";

/**
 * Represents the properties for the component.
 *
 * @typedef {Object} Props
 * @property {string[]} mikatanoServiceNames - An array of service names.
 */
type Props = {
  mikatanoServiceNames: string[];
};

/**
 * Display the special agreement page for the designated service targeted at clients who do not have account holding conditions.
 *
 * @param {Props} props - The properties passed to the component.
 * @returns {React.FC<Props>} A functional component that renders the special agreement page.
 */
export const TermsOfServiceNoAccountOwnedCriteriaPackageBillTypeInsurancePage =
  ({ mikatanoServiceNames }: Props) => {
    return (
      <TermsLayout
        title="指定サービスに関する特約"
        renderIntroduction={() => <Introduction />}
        renderArticles={() => {
          return [
            (i) => (
              <AritcleDesignatedService
                articleNumber={i}
                serviceNames={mikatanoServiceNames}
              />
            ),
            (i) => <ArticleProviderOfSpecifiedService articleNumber={i} />,
            (i) => <AritcleGoverningLawandJurisdiction articleNumber={i} />,
            (i) => <AritcleNegotiatedSettlement articleNumber={i} />,
          ];
        }}
      />
    );
  };
